import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.1665 10C2.1665 5.67379 5.67361 2.16669 9.99984 2.16669C14.3261 2.16669 17.8332 5.67379 17.8332 10C17.8332 14.3263 14.3261 17.8334 9.99984 17.8334C5.67361 17.8334 2.1665 14.3263 2.1665 10ZM8.95817 8.04169C8.33685 8.04169 7.83317 8.54537 7.83317 9.16669C7.83317 9.75998 8.29243 10.246 8.87483 10.2886L8.87484 13.5417C8.87484 14.163 9.37852 14.6667 9.99984 14.6667C10.6212 14.6667 11.1248 14.163 11.1248 13.5417L11.1248 9.16669C11.1248 8.54537 10.6212 8.04169 9.99983 8.04169H8.95817ZM9.99984 5.54169C9.37852 5.54169 8.87484 6.04537 8.87484 6.66669C8.87484 7.28801 9.37852 7.79169 9.99984 7.79169C10.6212 7.79169 11.1248 7.28801 11.1248 6.66669C11.1248 6.04537 10.6212 5.54169 9.99984 5.54169Z",
      fill: "currentColor",
      stroke: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }